// extracted by mini-css-extract-plugin
export default {"container":"BusinessQRCode_container__hufw3","qrcode":"BusinessQRCode_qrcode__Y23YZ"};